export default class WebWorker {
  constructor(worker, dependencies = []) {
    const code = worker.toString();
    const dependencyCode = dependencies
      .filter((dependency) => typeof dependency === "function")
      .map(
        (dependency) => `const ${dependency.name} = ${dependency.toString()};`,
      )
      .join("\n");

    const blob = new Blob([`${dependencyCode}\n(${code})()`], {
      type: "application/javascript",
    });

    return new Worker(URL.createObjectURL(blob));
  }
}

  